module.exports = __webpack_public_path__ + "static/media/1.549bfd39.jpg";